import React from 'react';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n-lite';
import { BottomSheet, BottomSheetAction, BottomSheetDivider } from '@netexknowledge/smart-components';

const EDIT_OPTION_KEY = 3;

/**
 * Orders the dropdown options for the mobile sheet: "Edit" first (no double tap on mobile)
 * and destructive options last, after a divider.
 */
export const orderSheetOptions = (options = []) => {
  const visible = options.filter(option => option && option.type !== 'divider');
  const edit = visible.filter(option => option.key === EDIT_OPTION_KEY && !option.danger);
  const danger = visible.filter(option => option.danger);
  const rest = visible.filter(option => option.key !== EDIT_OPTION_KEY && !option.danger);
  return { main: [...edit, ...rest], danger };
};

/**
 * Bottom sheet listing the same option items the desktop DropdownOptions receives
 * ({ key, text, icon, onClick, disabled }, plus optional nav, danger and description).
 */
const ActionSheet = ({ open, onClose, options, title, overline, media }) => {
  const { main, danger } = orderSheetOptions(options);

  const renderOption = option => (
    <BottomSheetAction
      key={option.key}
      icon={option.icon ? <i className={option.icon} /> : undefined}
      label={option.text}
      description={option.description}
      navigates={Boolean(option.nav)}
      danger={Boolean(option.danger)}
      disabled={Boolean(option.disabled)}
      onClick={() => {
        // Close first so a drawer or sheet opened by the option does not stack on this one
        onClose();
        if (option.onClick) {
          option.onClick();
        }
      }}
    />
  );

  return (
    <BottomSheet
      open={open}
      onClose={onClose}
      closeLabel={I18n.t('common.close')}
      title={title}
      overline={overline}
      media={media}
    >
      {main.map(renderOption)}
      {main.length > 0 && danger.length > 0 && <BottomSheetDivider />}
      {danger.map(renderOption)}
    </BottomSheet>
  );
};

ActionSheet.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  title: PropTypes.node,
  overline: PropTypes.node,
  media: PropTypes.node
};

export default ActionSheet;
